/**
 *
 * ParkingType12970 constants
 *
 */

export const FOR_UNLOADING_ZONE = '3745898130000';
export const PARKING = '3745898102000';
